'use client';

import { Modal, ModalBody, ModalFooter, ModalHeader } from '@mezzoforte/forge';
import { NextLinkButton } from '@/components/Link/LinkButton';
import { useSession } from '@/hooks/useSession';

export default function InfoReminderModal() {
  const { currentUser } = useSession();
  return (
    <Modal
      hideCloseButton
      verticalFooterButtons
      headerDivider
      isOpen={!!currentUser.data?.user?.isInfoMissing}
      onDismiss={() => {}}
    >
      <ModalHeader>Pyydämme päivittämään yhteystiedot</ModalHeader>
      <ModalBody>
        Täydennäthän yhteystietosi, jotta voit jättää tarjouksen. Tällä varmistamme, että pystymme olemaan sinuun
        asiakaspalvelusta tarvittaessa yhteydessä ja tuotteet toimitetaan oikeaan osoitteeseen.
      </ModalBody>
      <ModalFooter>
        <NextLinkButton
          variant="primary"
          href="/oma-sivu/kayttajatili"
          width="100%"
        >
          Jatka
        </NextLinkButton>
      </ModalFooter>
    </Modal>
  );
}
